import { c as _c } from "react/compiler-runtime";
import { FieldArray, useFormikContext } from 'formik';
import { useTranslations } from 'next-intl';
import { FormErrorMessage, NumberInput } from 'ui';
import { Select } from '~/components/Select';
import type { JourneyEditFormValues } from './JourneyEditForm.types';
const Details = () => {
  const $ = _c(53);
  const {
    getFieldProps,
    values
  } = useFormikContext();
  const t = useTranslations("journey");
  let t0;
  let t1;
  let t2;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <FormErrorMessage name="adult_count" />;
    t1 = <FormErrorMessage name="child_count" />;
    t2 = <FormErrorMessage name="childAges" />;
    t3 = <FormErrorMessage name="room_count" />;
    $[0] = t0;
    $[1] = t1;
    $[2] = t2;
    $[3] = t3;
  } else {
    t0 = $[0];
    t1 = $[1];
    t2 = $[2];
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t) {
    t4 = t("pax_adults_label");
    $[4] = t;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t4) {
    t5 = <span className="typography-emphasis-2">{t4}</span>;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t) {
    t6 = t("pax_adults_age");
    $[8] = t;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t6) {
    t7 = <span className="text-icons"> {t6}</span>;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== t5 || $[13] !== t7) {
    t8 = <div className="col-span-full">{t5}{t7}</div>;
    $[12] = t5;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <div className="col-span-full w-full"><div className="mx-auto w-36 md:mx-0"><NumberInput showErrors={false} name="adult_count" min={1} max={6} /></div></div>;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== t) {
    t10 = t("pax_children_label");
    $[16] = t;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== t10) {
    t11 = <span className="typography-emphasis-2">{t10}</span>;
    $[18] = t10;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  let t12;
  if ($[20] !== t) {
    t12 = t("pax_children_age");
    $[20] = t;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  let t13;
  if ($[22] !== t12) {
    t13 = <span className="text-icons"> {t12}</span>;
    $[22] = t12;
    $[23] = t13;
  } else {
    t13 = $[23];
  }
  let t14;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <div className="mx-auto w-36 md:mx-0"><NumberInput showErrors={false} name="child_count" min={0} max={6} /></div>;
    $[24] = t14;
  } else {
    t14 = $[24];
  }
  let t15;
  if ($[25] !== t11 || $[26] !== t13) {
    t15 = <div className="col-span-full md:col-span-1">{t11}{t13}{t14}</div>;
    $[25] = t11;
    $[26] = t13;
    $[27] = t15;
  } else {
    t15 = $[27];
  }
  let t16;
  if ($[28] !== t) {
    t16 = t("child_ages_legend");
    $[28] = t;
    $[29] = t16;
  } else {
    t16 = $[29];
  }
  let t17;
  if ($[30] !== t16) {
    t17 = <legend className="pb-1 typography-emphasis-2">{t16}</legend>;
    $[30] = t16;
    $[31] = t17;
  } else {
    t17 = $[31];
  }
  const t18 = `flex max-w-full gap-2 justify-around flex-wrap mb-2 md:block md:w-36 md:space-y-2 ${values.child_count <= 1 ? "items-center" : "items-start"}`;
  let t19;
  if ($[32] !== getFieldProps || $[33] !== t || $[34] !== values.child_count) {
    t19 = <FieldArray name="childAges">{() => Array.from({
        length: Math.max(values.child_count, 1)
      }).map((_, index) => <div key={index} className="w-36"><Select id={`child-${index + 1}`} required={true} disabled={values.child_count === 0} label={t("child_label", {
          number: index + 1
        })} labelVariant="small" {...getFieldProps(`childAges[${index}]`)}><option>{t("select_placeholder")}</option>{Array.from({
            length: 18
          }, _temp).map(age => <option value={values.child_count === 0 ? "Please select" : age} key={age}>{t("child_age_option", {
              age
            })}</option>)}</Select></div>)}</FieldArray>;
    $[32] = getFieldProps;
    $[33] = t;
    $[34] = values.child_count;
    $[35] = t19;
  } else {
    t19 = $[35];
  }
  let t20;
  if ($[36] !== t18 || $[37] !== t19) {
    t20 = <div className={t18}>{t19}</div>;
    $[36] = t18;
    $[37] = t19;
    $[38] = t20;
  } else {
    t20 = $[38];
  }
  let t21;
  if ($[39] !== t17 || $[40] !== t20) {
    t21 = <fieldset className="col-span-full md:col-span-1">{t17}{t20}</fieldset>;
    $[39] = t17;
    $[40] = t20;
    $[41] = t21;
  } else {
    t21 = $[41];
  }
  let t22;
  if ($[42] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = <hr className="col-span-full mb-4 text-icons" />;
    $[42] = t22;
  } else {
    t22 = $[42];
  }
  let t23;
  if ($[43] !== t) {
    t23 = t("rooms_heading");
    $[43] = t;
    $[44] = t23;
  } else {
    t23 = $[44];
  }
  let t24;
  if ($[45] !== t23) {
    t24 = <p className="col-span-full typography-emphasis-2">{t23}</p>;
    $[45] = t23;
    $[46] = t24;
  } else {
    t24 = $[46];
  }
  let t25;
  if ($[47] === Symbol.for("react.memo_cache_sentinel")) {
    t25 = <div className="col-span-full self-center md:col-span-1"><div className="mx-auto w-36 md:mx-0"><NumberInput showErrors={false} name="room_count" min={1} max={6} /></div></div>;
    $[47] = t25;
  } else {
    t25 = $[47];
  }
  let t26;
  if ($[48] !== t15 || $[49] !== t21 || $[50] !== t24 || $[51] !== t8) {
    t26 = <div className="grid grid-cols-2 typography-body-2">{t0}{t1}{t2}{t3}{t8}{t9}{t15}{t21}{t22}{t24}{t25}</div>;
    $[48] = t15;
    $[49] = t21;
    $[50] = t24;
    $[51] = t8;
    $[52] = t26;
  } else {
    t26 = $[52];
  }
  return t26;
};
export { Details };
function _temp(__0, k) {
  return k + 0;
}